import { render, staticRenderFns } from "./reportsStatistics.vue?vue&type=template&id=580dfe9e&scoped=true"
import script from "./reportsStatistics.vue?vue&type=script&lang=js"
export * from "./reportsStatistics.vue?vue&type=script&lang=js"
import style0 from "./reportsStatistics.vue?vue&type=style&index=0&id=580dfe9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580dfe9e",
  null
  
)

export default component.exports